import { AuthGuard, AuthService } from '@auth0/auth0-angular';
import { Observable, of } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OfflineCompatibleAuthGuard extends AuthGuard {
  constructor(private readonly authService: AuthService) {
    super(authService);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return navigator.onLine ? super.canActivate(route, state) : of(true);
  }
}
